module.exports = __webpack_public_path__ + "img/4-2-4-2-3-preview-Canada-Credit-goingawesomeplaces-e.5fcf4f68.jpg";